export function decodeJwtPayload<T>(token: string): T {
  const payload = token.split(".")[1] ?? "";
  const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized + "=".repeat((4 - (normalized.length % 4)) % 4);

  return JSON.parse(atob(padded)) as T;
}
